import Botao from 'components/Botao';
import style from './Page404.module.css';
import { useNavigate } from 'react-router-dom';
import { faFileCircleQuestion } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import WallpaperMenu from 'components/WallpaperMenu';
import MainAvisos from 'components/MainAvisos';

export default function Page404() {
    const navigate = useNavigate();

    function voltarPLogin() {
        navigate('/');
    }
    return (
        <>
            <WallpaperMenu />
            <MainAvisos>
                <FontAwesomeIcon icon={faFileCircleQuestion} className={style.icon} />
                <h1>
                    Erro 404
                </h1>
                <p>
                    Página não encontrada
                </p>
                <p>
                    Volte para a página inicial
                </p>
                <Botao onClick={voltarPLogin}>Voltar</Botao>
            </MainAvisos >
        </>
    )
}
